<template lang="pug">
  ul.primary-navigation
    li.primary-navigation__node(
      v-for="menuItem in menuItems"
      :key="menuItem.title"
      @focusout="handleNodeFocusout(menuItem.title)"
      :ref="nodeRef(menuItem.title)"
      @mouseleave="hideSubnav"
    )
      .primary-navigation__link(
        :class="toKebabCase(menuItem.title) === openSubnav ? 'primary-navigation__link--open-subnav' : ''"
        :is="menuItem.url ? 'a' : 'div'"
        :tabindex="menuItem.url ? null : 0"
        :href="menuItem.url"
        @mouseenter="showSubnav(toKebabCase(menuItem.title))"
        @focus="showSubnav(toKebabCase(menuItem.title))"
        v-if="hasSubnav(menuItem)"
      ) {{ menuItem.title }}
      a.primary-navigation__link(
        :href="menuItem.url"
        @mouseenter="hideSubnav"
        @focus="hideSubnav"
        v-else
      ) {{ menuItem.title }}

      transition(
        name="fade"
        v-if="hasSubnav(menuItem)"
      )
        subnav(
          :key="`${toKebabCase(menuItem.title)}_${_uid}`"
          v-if="openSubnav && openSubnav === toKebabCase(menuItem.title)"
          @blur="hideSubnav"
          :menuItem="menuItem"
        )
</template>
<script>
  import Subnav from 'scripts/components/site-header/Subnav.vue';
  import { toKebabCase } from 'scripts/helpers/util';

  export default {
    name: 'PrimaryNavigation',
    components: { Subnav },
    props: {
      menuItems: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        openSubnav: null,
      };
    },
    methods: {
      showSubnav(subnav) {
        this.openSubnav = subnav;
      },
      hideSubnav() {
        this.openSubnav = null;
      },
      hasSubnav(menuItem) {
        return menuItem.children.length;
      },
      toKebabCase(stringToAlter) {
        return toKebabCase(stringToAlter);
      },
      handleNodeFocusout(name) {
        if (!this.hasFocusedElement(this.nodeRef(name))) {
          this.hideSubnav();
        }
      },
      hasFocusedElement(nodeRef) {
        return this.$refs[nodeRef][0].matches(':focus-within');
      },
      nodeRef(name) {
        return name.replace(' ', '-');
      },
    },
  };
</script>

<style lang="scss">
  .primary-navigation {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0 50px;
    list-style: none;
    height: 100%;
  }

  .primary-navigation__node {
    padding: 0 $spacing-unit * 1.5;

    &:last-child {
      background-color: $color-orange;
    }
  }

  .primary-navigation__link {
    display: inline-block;
    color: $color-black;
    font-size: rem(14px);
    line-height: 60px;
    font-weight: 500;
    text-decoration: none;
    text-transform: uppercase;
    cursor: pointer;

    &:hover,
    &.primary-navigation__link--open-subnav {
      color: $color-orange;
    }

    .primary-navigation__node:last-child & {
      color: $color-white;

      &:hover {
        color: $color-white;
      }
    }
  }
</style>
